/**
 * Created by Yoyo Fang on 4/19/2019.
 * Description: Add contact page
 * ------ maintenance history ------
 * 06/06/2019   Yoyo Fang   when reload triggered from external ,silently set text on keyword search
 * 09/05/2019   Ella Ma     upgrade ag-grid-angular
 * 10/07/2020   Alex update contact list grid information and use slide sheet instead of contact detail component
 * 10/13/2021   Marcus Zhao add exchange import button and check exchange status
 * Updated by Daniel on 1/11/2022: Combined the entity-list.base component with entity-list component. because input parameters in the extends   component can't be passed in build mode when upgradint to angular10 from angular8.
 * Updated by Marcus Zhao on 6/11/2022: support filter contacts by contact filter data.
 * Updated by Marcus Zhao on 7/1/2022 : Support contact bulk action to exchange.
 * Updated by Marcus Zhao on 7/4/2022 : Move some variables to contact list service.
 * Updated by Marcus Zhao on 12/10/2022 : Support set owner status and refresh contact list.
 * Updated by Marcus Zhao on 12/13/2022 : Support download excel .1.download current contacts.2.download all contacts.
 */
import { Component, OnInit, OnDestroy, HostListener, Input, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { GridOptions, ColDef, GridApi } from 'ag-grid-community';
import { Subject, Subscription } from 'rxjs';
import { catchError, filter, map, take } from 'rxjs/operators';
import { of as observableOf } from 'rxjs';
import { smartSelector } from '../../redux';
import { ScreenActionTypes } from '../../redux/actions/screen.actions';
import { lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
import { getSystemConfigState } from '../../redux/reducers/system-config-view.reducer';
import { ContactListAction, ContactListActionType, ContactListConfig, ContactListFeedBack, ContactListFeedbackType } from '../../tamalelibs/components/contact-list.config';
import { ContactsViewConstants } from '../../tamalelibs/models/smart-reducer.model';
import { EDIT_CONTACT_SUCCESS } from '../../tamalelibs/redux/app.actions';
import { ContactService } from '../../tamalelibs/services/contact.service';
import { ContactList } from '../../tamalelibs/models/entity-list.model';
import { RELOAD_CONTACTS } from '../../tamalelibs/redux/contact-list.actions';
import { businessConstants } from '../../constants/business.constants';
import { DEFAULT_PAGE_SIZE } from '../../widgets/grid/grid.model';
import { ResearchLayoutConfig } from '../../components/research-layout/research-layout.data';
import { ContactConfig, ContactFeedbackAction, ContactFeedbackTypes } from '../contact/contact.model';
import { KeywordSearchConfig } from '../../widgets/keyword-search/keyword-search.component';
import { SlideSheetActionTypes, SlideSheetEventTypes } from '../../components/slide-sheet/slide-sheet.model';
import { SlideSheetService } from '../../services/slide-sheet.service';
import { ContextMenuConfig, ContextMenuShowAction } from '../../widgets/tam-context-menu/tam-context-menu.model';
import { ExchangeImportCheckDialogService } from '../../components/exchange/exchange-import-check-dialog/exchange-import-check-dialog.service';
import { ExchangeDialogOptions } from '../../components/exchange/exchange-import-check-dialog/exchange-import-check-dialog.model';
import { StoreQuerierService } from '../../services/store-querier.service';
import { NotificationStyles, NotificationOptions } from '../../widgets/notification/notification.model';
import { ToastService } from '../../widgets/toast/toast.service';
import { ExchangeService } from '../../tamalelibs/services/exchange.service';
import { userSettingSelector } from '../../redux/reducers/users.reducer';
import { UsersActionTypes } from '../../redux/actions/users.actions';
import { SearchAction } from '../../tamalelibs/constants/business.constants';
import { ContactListService } from './contact-list.service';
import { ButtonConfig, SplitButtonConfig } from '../../widgets/split-button/split-button.model';
import { MessageService } from '../../services/message.service';
import { MessageType } from '../../tamalelibs/models/message.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { AlertBtnTypes } from '../../widgets/alert-window/alert-window.model';
import * as _lodash from 'lodash';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';
import { ExchangeBuklActionType } from '../../tamalelibs/models/contact.model';
import { SortInfo } from '../file-view/file-view.model';
import { AUTO_SAVE_INTERVAL_5 } from '../../../../../tamalelibs/src/app/constants/business.constants';
import { FileHelperService } from '../../services/file-helper.service';
import { CommonUtilities } from '../../services/utilities/common-utilities';
import { GridCustomColumnFeedbackTypes } from '../../widgets/ag-grid/custom-action-column.model';
import { SourceType } from '../entity/entity.model';
const ALWAYS = 'always';
const NEVER = 'never';
const INIT = 'init';
const UICOLUMNDRAGGED = 'uiColumnDragged';
@Component({
    selector: 'tam-contact-list',
    templateUrl: './contact-list.component.html',
    styleUrls: ['./contact-list.component.scss']
})
export class ContactListComponent implements OnInit, OnDestroy {
    @Input() config: ContactListConfig;
    bulkProgress = '0%';
    bulkFinishedResult = '';
    bulkFinishedTip = '';
    bulkProgressHeader = '';
    columnDefsOrignal: Array<ColDef>;
    columnDefs: Array<ColDef>;
    contactConfig: ContactConfig;
    contactId: string = null;
    contactList: ContactList;
    filters: object = {};
    filterParams = {};
    filterIcon = 'filter-o';
    gridOptions: GridOptions;
    hasBulkOnce = false;
    inited = false;
    isExchangeEnable = false;
    isExportCurrentViewAll = false; // to be used by exporting all excel data
    isRowDeletedTriggered = false;
    isShowSynchLabel = true;
    isShowExchangeSync = false;
    isShowFilter = false;
    isShowProgressBar = false;
    isReload = false;
    isRefresh = false; // click refresh button ,will be show notification after refresh successfully.
    isShowBulkAction = false;
    isProgressing = false;
    isShowBulkFailedResult = false;
    isShowGrid = true;
    interval;
    keyword = '';
    keywordSearchConfig: KeywordSearchConfig;
    layoutConfig: ResearchLayoutConfig;
    loadingMore = false;
    loading = false;
    noData = false;
    operationContextMenuConfig: ContextMenuConfig;
    exportContextMenuConfig: ContextMenuConfig;
    page = 1;
    parentId = '';
    progressColor = '';
    reloading = false;
    selectedIndex = 0;
    sorts: object = {};
    sortBy = 'full-name';
    sortOrder = 'asc';
    splitButtonConfig: SplitButtonConfig;
    syncType = 0;
    /** set uncheck contact for exclues data */
    uncheckList: Set<string> = new Set<string>();

    private _currentUser;
    private _firstLoad = true;
    private _isAdminUser = false;
    private _isComplianceUser = false;
    private _isPPCUser;
    private _gridApi: GridApi;
    private _gridColumnApi;
    private _gridClicked = false;
    private _oneBulkActionId: string;
    private _oneBulkActionFailId: string;
    private _selectedId = '';
    private _subscriptions: Array<Subscription> = [];
    private _sortInfo: any;
    private _columnApi: any;
    private _timer: any;
    private _userSetting;

    constructor(
        private _contactService: ContactService,
        private _contactListService: ContactListService,
        private _exchangeImportCheckDialogService: ExchangeImportCheckDialogService,
        private _exchangeService: ExchangeService,
        private _fileHelperService: FileHelperService,
        private _messageService: MessageService,
        private _route: ActivatedRoute,
        private _router: Router,
        private _slideSheetService: SlideSheetService,
        private _store: Store<any>,
        private _storeQuerier: StoreQuerierService,
        private _toast: ToastService,
        private _alert: AlertWindowService,
        private _changeDetectorRef: ChangeDetectorRef,
    ) {
        this._currentUser = this._storeQuerier.getCurrentUser();
        if (this._currentUser) {
            this._isAdminUser = this._currentUser.credential.admin;
            this._isComplianceUser = this._currentUser.credential.compliance;
            this._isPPCUser = this._currentUser.credential.publishPubConfiguration;
        }
        // get the status of isShowBulkAction
        const feedback = this._router.getCurrentNavigation()?.extras?.state;
        if (feedback) {
            this.isShowBulkAction = feedback['isShowBulkAction'];
            this.keyword = feedback['keyword'] ?? '';
            if (this.isShowBulkAction) {
                this._initSplitButton();
            }
        }
    }

    ngOnInit() {
        // Init columnDefs and grid option for contact ag-grid
        this.columnDefs = _lodash.cloneDeep(this._contactListService.columnDefs);
        this.columnDefsOrignal = _lodash.cloneDeep(this.columnDefs);
        this._contactListService.compareValue(this.columnDefs);
        this.gridOptions = this._contactListService.gridOptions;
        this.gridOptions.rowGroupPanelShow = NEVER;
        this.layoutConfig = new ResearchLayoutConfig(3, true, true);
        this.contactConfig = new ContactConfig(true);
        this.keywordSearchConfig = new KeywordSearchConfig();
        this._subscriptions.push(
            this.contactConfig.feedbackSubject$.subscribe((action: ContactFeedbackAction) => this._contactFeedbackHandler(action)),
            // Get grid check status.
            this._contactListService.feedbackSubject$.subscribe(feedback => this._handleGridFeedback(feedback)),
            this._contactListService.gridFeedbackSubject$.subscribe(feedback => this._handleGridColumnFeedback(feedback))
        );
        this._subscriptions.push(
            this.keywordSearchConfig.events$.subscribe((action: any) => this._keywordSearchFeedbackHandler(action)),
            // Get notification by websocket.
            this._messageService.messageSubject$.subscribe(action => this._onMessageAction(action)),
        );
        this._subscriptions.push(
            this._store.pipe(
                select(lastCustomActionSelector),
            ).subscribe(action => this._actionMessageHandler(action)),
            this._store.pipe(
                select(userSettingSelector),
                filter(data => data),
            ).subscribe((res) => {
                // if setting response later than get contact .should reload get contact after get user settings.
                if (res && this.isReload && this._firstLoad) {
                    this._firstLoad = false;
                    this._restoreState();
                    this._reload(this._getParams(), INIT);
                }
            })
        );
        const systemConfig = this._storeQuerier.queryBySelector(getSystemConfigState);
        if (systemConfig && systemConfig.exchange) {
            this.isExchangeEnable = systemConfig.exchange['enable'];
            this.isShowExchangeSync = systemConfig.autoSyncSetConfig['enable'];
        }
        this._initExportExcelContextMenu();
        this._initOperationConfigContextMenu();
    }

    ngOnDestroy() {
        this._subscriptions.forEach(subscription => {
            if (subscription && !subscription.closed) {
                subscription.unsubscribe();
            }
        });
        clearInterval(this.interval);
    }

    clickFilter($event) {
        this.isShowFilter = !this.isShowFilter;
    }

    clickApplyFilter(action) {
        this.isShowFilter = false;
        // Due to apply filter, need to reset pageSize.
        this.page = 1;
        if (action) {
            if (action.hasFilter) {
                this.filterIcon = 'filter';
            } else {
                this.filterIcon = 'filter-o';
            }
            // the sortOrder/sortby should be the same as the current user setting.
            action.payload.sortBy = this.sortBy;
            action.payload.sortOrder = this.sortOrder;
            this.isReload = false;
            if (this.keyword) {
                action.payload.keyword = this.keyword;
            } else {
                this.keywordSearchConfig.actions$.next({ type: SearchAction.clear });
            }
            this._store.dispatch(action);
        }
    }

    /**
     * Get check count by user,user only select all then uncheck some items.
     * @returns total check count.
     */
    checkCount() {
        return this.contactList?.totalCount - this.uncheckList?.size;
    }

    clickRefreshContactList() {
        // If user click refresh,need to load data from page 1.
        this.page = 1;
        this._reload(this._getParams(), INIT, true);
    }

    clickSelectedAll() {
        this.contactList.contacts.forEach(item => item['isChecked'] = true);
        this._gridApi.setRowData(this.contactList.contacts);
        this.uncheckList.clear();
        this.splitButtonConfig.feedbackSubject$.next(this.checkCount() <= 0);
    }

    downloadCurrentContactListToExcel() {
        this._gridApi.exportDataAsExcel({
            fileName: `${businessConstants.Contacts.Contacts} (current view)`,
            sheetName: `${businessConstants.Contacts.Contacts} (current view)`,
        });
    }

    /**
     * Download contact list
     */
    downloadAllContactListToExcel() {
        this._userSetting = this._storeQuerier.queryBySelector(userSettingSelector);
        if (this._userSetting && this._userSetting.contactFilter) {
            this.filterParams = this._userSetting.contactFilter.configuration.filterParams;
        }
        this._contactService.downloadContactList(this.sortBy, this.sortOrder, this.keyword, this.filterParams).pipe(take(1)).subscribe(data => {
            if (data instanceof ArrayBuffer) {
                this._fileHelperService.downloadFunction(data, `${businessConstants.Contacts.Contacts} (all).xlsx`);
                this._changeDetectorRef.detectChanges();
            }
        }, error => {
            // TODO need research how to handle error case for responseType='arraybuffer'
            this._changeDetectorRef.detectChanges();
        });
    }

    getRecord() {
        if (this.contactList) {
            if (this.contactList.totalCount === 0) {
                return StringLiteralsPipe.translate('crm.0_record');
            } else {
                return `${this.contactList.totalCount} records`;
            }
        }

    }

    /**
     * Click Exit button
     */
    onButtonClick() {
        if (this.isProgressing) {
            this._alert.warn(StringLiteralsPipe.translate('crm.exit_warning_1'),
                [StringLiteralsPipe.translate('crm.exit_warning_2')], 'Exit', 'Go back')
                .pipe(take(1)).subscribe(result => {
                    if (result) {
                        this._resetDataAfterClick();
                    }
                });
        } else {
            this._resetDataAfterClick();
        }
    }



    onColumnVisible() {
        this._saveState();
    }

    onColumnMoved(e) {
        if (e.source === UICOLUMNDRAGGED) {
            this._saveState();
        }
    }

    onColumnResized(e) {
        if (e.source === UICOLUMNDRAGGED && e.finished) {
            this._saveState();
        }
    }

    onColumnPinned() {
        this._saveState();
    }

    onBodyScroll(e) {
        if (this.contactList && this.contactList.next && !this.loadingMore && e.api.gridBodyCtrl) {
            if (e.top + e.api.gridBodyCtrl.eBodyViewport.clientHeight + 1000 > e.api.gridBodyCtrl.eBodyViewport.scrollHeight) {
                this.loadingMore = true;
                this.page++;
                if (this.isShowBulkFailedResult) {
                    this._getBulkActionResult();
                } else {
                    this._reload(this._getParams(), 'scroll');
                }
            }
        }
    }

    onDisplayedColumnsChanged(event) {
        event.api.sizeColumnsToFit();
    }

    onGridClick(event) {
        this._gridClicked = true;
    }


    /*AG Grid */
    onGridReady(params) {
        this._gridApi = params.api;
        this._gridColumnApi = params.columnApi;
        // if before grid ready config ready, means component being reused as embedded
        // else means component self starts as url controller
        if (this.config) {
            this._initComponent(null);
        } else {
            const config = new ContactListConfig(
                smartSelector(null, ContactsViewConstants.ReducerName)
            );
            const selfInitSubscription = config.feedbackSubject.subscribe((feedback: ContactListFeedBack) => {
                if (feedback.type === ContactListFeedbackType.VIEW_READY) {
                    this._reload(this._getParams(), INIT);
                    selfInitSubscription.unsubscribe();
                }
            });
            const currentPageInfo: any = {
                url: this._route.snapshot.url,
                name: 'Contacts',
                type: 'CONTACTS',
                screenType: businessConstants.screenType.contact
            };
            this._store.dispatch({
                type: ScreenActionTypes.SET_VALUE,
                payload: currentPageInfo
            });
            this._initComponent(config);
        }
        this.config.feedbackSubject.next(new ContactListFeedBack(ContactListFeedbackType.VIEW_READY, null));
        this._restoreState();

        if (this.isShowBulkAction) {
            this.keywordSearchConfig.actions$.next({ type: 'SET', payload: this.keyword, silentChange: true });
            this.gridOptions.rowGroupPanelShow = NEVER;
            this.isShowBulkFailedResult = false;
            // Can't update columnDefs directly ,so reset columnDefs.
            const data = _lodash.cloneDeep(this.columnDefs);
            data.splice(0, 0, this._contactListService.checkColumnDef);
            data.forEach(item => {
                if (item.colId === 'owner' && item.hide) {
                    item.hide = false;
                }
            });
            // add delete column to grid
            if (this._isAdminUser && this._isComplianceUser) {
                data.push(this._contactListService.deleteColumnDef);
            }
            this.columnDefs = [];
            this._gridApi.setColumnDefs(this.columnDefs);
            this.columnDefs = data;
            this._gridApi.setColumnDefs(this.columnDefs);
            this.contactList.contacts.forEach(item => item['isChecked'] = true);
            this._gridApi.setRowData(this.contactList.contacts);
        }
        this._changeDetectorRef.detectChanges();
    }

    /**
     * reset column status by store setting
     */
    private _restoreState() {
        this._userSetting = this._storeQuerier.queryBySelector(userSettingSelector);
        if (this._userSetting && this._userSetting.contactListColumn && this._userSetting.contactListColumn.configuration && this._userSetting.contactListColumn.configuration.setting) {
            const a = this._userSetting.contactListColumn.configuration.setting;
            this._gridColumnApi.applyColumnState({
                state: a,
                applyOrder: true,
            });
        }

        if (this._userSetting && this._userSetting.contactListSort && this._userSetting.contactListSort.configuration && this._userSetting.contactListSort.configuration.sortInfo) {
            this._sortInfo = this._userSetting.contactListSort.configuration.sortInfo;
            if (this._sortInfo) {
                const sort = [
                    {
                        colId: this._sortInfo.sortBy,
                        sort: this._sortInfo.sortOrder
                    }
                ];
                this._gridColumnApi.applyColumnState({ state: sort });
            }
        }
        this._changeDetectorRef.detectChanges();
    }

    @HostListener('window:keydown', ['$event'])
    onKeydown(event) {
        let selectNode = null;
        // use up/down arrow keys to select through items
        if (event.keyCode === 40) { // down
            // get the index of last selected item
            let nextIndex = this.selectedIndex;
            if (++nextIndex < this.contactList.contacts.length) {
                this._gridApi.forEachNode(function (node) {
                    if (node.rowIndex === nextIndex) {
                        selectNode = node;
                        node.setSelected(true);
                    } else {
                        node.setSelected(false);
                    }
                });
                this.onRowClicked(null, selectNode);
            }
        } else if (event.keyCode === 38) { // up
            // get the index of first selected item
            let nextIndex = this.selectedIndex;
            if (--nextIndex > -1) {
                this._gridApi.forEachNode(function (node) {
                    if (node.rowIndex === nextIndex) {
                        selectNode = node;
                        node.setSelected(true);
                    } else {
                        node.setSelected(false);
                    }
                });
                this.onRowClicked(null, selectNode);
            }
        }
    }

    onMousedown(event) {
        if (event.srcElement && event.srcElement.nodeName === 'INPUT') {
            return;
        }
        // Click grid to open side shite. It will not be opened or closed repeatedly. It will always be open, but only the content will be updated - event.preventDefault()
        // grid key down/up, so not call event.preventDefault()
        if (event.stopPropagation) {
            event.stopPropagation();
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(e) {
        if (!this._gridApi) {
            return;
        }
        this._gridApi.sizeColumnsToFit();
    }

    onRowClicked(event, node?) {
        if (!this.isRowDeletedTriggered) {
            let item;
            if (node) {
                item = node;
            } else {
                item = event.api.getSelectedNodes()[0];
            }
            if (item && item.data && item.data.id) {
                if (this._gridClicked) {
                    this._gridClicked = false;
                }
                this._slideSheetService.slideSheetActionSubject$.next({
                    type: SlideSheetActionTypes.CONTACT_PANEL,
                    payload: item.data.id
                });
            }
            this._onClicked(item.rowIndex);
        } else {
            this.isRowDeletedTriggered = false;
        }
    }

    onSendEmailButtonClick() {
        const bulkSendEmailsTitle = StringLiteralsPipe.translate('crm.bulk_action_send_emails_title', this.checkCount().toString());
        const bulkSendEmailsTip = StringLiteralsPipe.translate('crm.bulk_action_send_emails_tip');

        this._alert.warn(bulkSendEmailsTitle, [bulkSendEmailsTip], 'Confirm', 'Discard', '', '', AlertBtnTypes.primary).pipe(
            take(1),
        ).subscribe(result => {
            if (result) {
                this._loadEmailWithSendTo();
            }
        });
    }

    onSortChanged(e) {
        const columnState = this._gridColumnApi.getColumnState();
        const sortModel = columnState
            .filter(column => column.sort)
            .map(column => ({ colId: column.colId, sort: column.sort }));

        if (sortModel && sortModel.length > 0) {
            this.sortBy = sortModel[0].colId;
            this.sortOrder = sortModel[0].sort;
            this.page = 1;
            this._reload(this._getParams(), INIT);
            if (!this._sortInfo) {
                this._sortInfo = new SortInfo();
            }
            this._sortInfo.sortBy = this.sortBy;
            this._sortInfo.sortOrder = this.sortOrder;

            // init grid status
            this._saveState();
            // trigger reload, for save screen
            this._triggerSortChanged(this._sortInfo);
        }
    }

    showContextMenu(e: MouseEvent) {
        this.operationContextMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
    }

    showExcelContextMenu(e: MouseEvent) {
        this.exportContextMenuConfig.show$.next(new ContextMenuShowAction(e, ''));
    }

    /**
     * synch contacts from Exchange
     *
     * @param {*} id
     * @memberof ContactListComponent
     */
    private _synchTamaleContactFromExchagne(id) {
        this._contactService.synchAllExchangetoTamale().pipe(
            take(1),
        ).subscribe(data => {
        },
            error => {
                const _failedToast: NotificationOptions = {
                    message: error.message,
                    style: NotificationStyles.Error

                };
                this._toast.notify(_failedToast);
            }
        );
    }

    private _actionMessageHandler(action) {
        if (action.type === EDIT_CONTACT_SUCCESS) {
            this.page = 1;
            this._reload(this._getParams(), 'updated');
            this._selectedId = action.payload.id;
        }
    }

    private _contactFeedbackHandler(feedback: ContactFeedbackAction) {
        switch (feedback.type) {
            case ContactFeedbackTypes.CONTACT_LOADED:
                break;
            case ContactFeedbackTypes.CONTACT_UPDATED:
                this._reload(this._getParams(), 'updated');
                break;
        }
    }

    private _clearTimer(): void {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    }

    private _handleGridColumnFeedback(res) {
        if (res.type === GridCustomColumnFeedbackTypes.DELETE) {
            this._router.navigate(['contact', res.payload.data.id, 'associated-info'], { state: res.payload.data, queryParams: { source: '' + SourceType.CONTACT + '', keyword: '' + this.keyword + '' } });
        }
    }

    /**
     * when check one item,should keep check status and refresh
     * Data
     * set uncheck to uncheckList for exclues data.
     * @param res
     */
    private _handleGridFeedback(res) {
        const data = res.payload.data;
        this.contactList.contacts.forEach(element => {
            if (element.id === data.id) {
                element['isChecked'] = data.isChecked;
            }
        });
        if (this.uncheckList.has(data.id) && data.isChecked) {
            this.uncheckList.delete(data.id);
        } else {
            this.uncheckList.add(data.id);
        }
        // if select 0 ,split button should be disabled.
        this.splitButtonConfig.feedbackSubject$.next(this.checkCount() <= 0);
    }

    private _getParams() {
        this._userSetting = this._storeQuerier.queryBySelector(userSettingSelector);
        if (this._userSetting && this._userSetting.contactFilter) {
            this.filterParams = this._userSetting.contactFilter.configuration.filterParams;
            // display different status icon by filterParams.
            if (this.filterParams) {
                this.filterIcon = 'filter';
            } else {
                this.filterIcon = 'filter-o';
            }
        }
        return {
            keyword: this.keyword,
            pageSize: this.isExportCurrentViewAll ? businessConstants.Contacts.MaxNumber : DEFAULT_PAGE_SIZE,
            page: this.page,
            sortBy: this.sortBy,
            sortOrder: this.sortOrder,
            filter: this.filterParams
        };
    }

    private _initComponent(config: ContactListConfig) {
        if (!this.config) {
            this.config = config;
        }
        this._subscriptions.push(this.config.actionSubject.subscribe((action: ContactListAction) => {
            if (action.type === ContactListActionType.RELOAD) {
                if (action && action.payload) {
                    this.keyword = action.payload.keyword;
                }
                this._reload(action.payload, 'external');
            }
        }));

        this._subscriptions.push(this._store.select(this.config.rootSelector).subscribe((state) => {
            if (state) {
                this._onSubscribeContactList(state);
            }
        }));

        // If contact changed from contact detail. we need to change current item and keep check status.
        this._subscriptions.push(this._slideSheetService.slideSheetFeedbackSubject$.subscribe(res => {
            if (res.type === SlideSheetEventTypes.CONTACT_VALUE_CHANGE) {
                this.contactList.contacts.forEach((element, index) => {
                    if (res.payload && element.id === res.payload.id) {
                        const temp = element['isChecked'] || false;
                        this.contactList.contacts[index] = res.payload;
                        this.contactList.contacts[index]['isChecked'] = temp;
                    }
                });
                this._gridApi.setRowData(this.contactList.contacts);
                // reset selected row
                this._setSelectedRow(res.payload.id);
            }
        }));
    }

    private _initOperationConfigContextMenu() {
        this.operationContextMenuConfig = new ContextMenuConfig();
        this.operationContextMenuConfig.stateful = false;
        this.operationContextMenuConfig.showItemIcon = false;
        this.operationContextMenuConfig.clickOnDiv = true;
        this.operationContextMenuConfig.items = [];
        if (this.isExchangeEnable) {
            this.operationContextMenuConfig.items.push(
                { id: '0', text: StringLiteralsPipe.translate('crm.import_contacts_from_exchange') }
            );
        }
        if ((this.isShowExchangeSync && this.isExchangeEnable) || this._isPPCUser) {
            this.operationContextMenuConfig.items.push(
                { id: '1', text: StringLiteralsPipe.translate('crm.auto_sync_preference') }
            );
        }
        this.operationContextMenuConfig.items.push(
            { id: '2', text: StringLiteralsPipe.translate('crm.bulk_actions') }
        );
        if (this.isExchangeEnable) {
            this.operationContextMenuConfig.items.push(
                { id: '3', text: StringLiteralsPipe.translate('crm.sync_connected_contacts') }
            );
        }
        this.operationContextMenuConfig.events$.subscribe(event => this._onOperationMenuSelect(event));
    }

    /**
     * Init export contact menu ,include
     */
    private _initExportExcelContextMenu() {
        this.exportContextMenuConfig = new ContextMenuConfig();
        this.exportContextMenuConfig.stateful = false;
        this.exportContextMenuConfig.showItemIcon = false;
        this.exportContextMenuConfig.clickOnDiv = true;
        this.exportContextMenuConfig.items = [
            { id: '0', text: StringLiteralsPipe.translate('crm.export_current_contacts_to_excel') },
            { id: '1', text: StringLiteralsPipe.translate('crm.export_all_contacts_to_excel') }
        ];
        this.exportContextMenuConfig.events$.subscribe(event => this._onOperationExportMenuSelect(event));
    }

    /**
     * Init split button,include one way and two way connected.
     */
    private _initSplitButton() {
        this.splitButtonConfig = {
            primaryAction: {
                displayText: StringLiteralsPipe.translate('crm.export_to_exchange'),
                onClick: () => {
                    this._onBulkButtonClick(1);
                }
            } as ButtonConfig,
            secondaryActions: [
                {
                    displayText: StringLiteralsPipe.translate('crm.export_to_exchangeAndTakeOwnerShip'),
                    onClick: () => {
                        this._onBulkButtonClick(2);
                    }
                },
                {
                    displayText: StringLiteralsPipe.translate('crm.remove_owner_of_selected_contacts'),
                    onClick: () => {
                        this._onBulkButtonClick(3);
                    }
                },
            ]
        } as SplitButtonConfig;
        this.splitButtonConfig.feedbackSubject$ = new Subject<any>();
        if (this.contactList?.totalCount <= 0 || !this._currentUser.credential.admin) {
            setTimeout(() => {
                this.splitButtonConfig.feedbackSubject$.next(true);
            });
        }
    }

    /**
     * Get result data for bulk action and refresh grid row data.
     * Currently only get failed list.
     */
    private _getBulkActionResult() {
        this.isProgressing = false;
        if (this.syncType === ExchangeBuklActionType.remove) {
            this._oneBulkActionId = this._oneBulkActionFailId;
        }
        this._contactService.getBulkContactList(this._oneBulkActionId, this.page, DEFAULT_PAGE_SIZE)
            .pipe(
                take(1),
                catchError((error) => {
                    const _failedToast: NotificationOptions = {
                        message: error.message,
                        style: NotificationStyles.Error
                    };
                    this._toast.notify(_failedToast);
                    return observableOf(null);
                }))
            .subscribe(res => {
                if (res) {
                    // If it is not progressing,need to stop operations of bulk Action  and clear interval.
                    if (!this.isShowBulkAction) {
                        clearInterval(this.interval);
                        this.isShowGrid = true;
                        return;
                    }
                    this.isShowBulkFailedResult = res.count > 0;
                    const data = this._contactService.mapContactList(res);
                    // set hasBulkOnce for prepare next child bulk action.
                    if (data.contacts.length > 0) {
                        this.hasBulkOnce = true;
                    }
                    this.contactList = data;
                    if (this.uncheckList && this.contactList) {
                        this.contactList.contacts.forEach(item => {
                            if (this.uncheckList.has(item.id)) {
                                item['isChecked'] = false;
                            }
                        });
                    }
                    this.uncheckList.clear();
                    this.checkCount();
                    this._gridApi.setRowData(this.contactList.contacts);
                }
            });
    }

    /**
     *
     * @returns set Progressbar color by bulk result.
     */
    private _getProgressColor() {
        if (this.bulkProgress === '100%') {
            return !this.isShowBulkFailedResult ? 'progress-bar-success' : 'progress-bar-error';
        }
    }

    /**
     *  Design with PM ,get progressbar precent by  every 5s.
     *  Caculate percentage by (failedNum +successNum)*100 / targestListNum
     */
    private _getBulkStatusByInterval() {
        const _this = this;
        this.interval = setInterval(() => {
            this._contactService.getOneBulkAction(this._oneBulkActionId)
                .pipe(
                    take(1),
                    catchError((error) => {
                        return observableOf(null);
                    }))
                .subscribe(res => {
                    if (!this.isShowBulkAction) {
                        clearInterval(this.interval);
                        this.isShowGrid = true;
                        return;
                    }
                    this.bulkProgress = Math.round((res.failedNum + res.succeedNum) * 100 / res.targetListNum) + '%';
                    this.bulkFinishedResult = StringLiteralsPipe.translate('crm.bulk_action_progress_complete', this.bulkProgress);
                    if (res.isDone) {
                        if (this.syncType === ExchangeBuklActionType.takeOneWay || this.syncType === ExchangeBuklActionType.takeTwoWay) {
                            this.splitButtonConfig.feedbackSubject$.next(false);
                            this.isProgressing = false;
                            this.bulkProgressHeader = StringLiteralsPipe.translate('crm.progress_header_finished', res.succeedNum);
                            if (res.failedNum === 0) {
                                this.splitButtonConfig.feedbackSubject$.next(true);
                                this.isShowBulkFailedResult = false;
                                this.isShowGrid = false;
                                this.bulkFinishedResult = StringLiteralsPipe.translate('crm.bulk_action_complete');
                            } else {
                                this.isShowGrid = true;
                                this.isShowBulkFailedResult = true;
                                this.bulkFinishedResult = StringLiteralsPipe.translate('crm.contacts_are_exported_successfully', res.succeedNum);
                                if (res.failedReasons && res.failedReasons.length === 1 && res.failedReasons[0] === 'othersHasOwnership') {
                                    this.bulkFinishedTip = StringLiteralsPipe.translate('crm.below_contacts_tips');
                                } else {
                                    this.bulkFinishedTip = StringLiteralsPipe.translate('crm.error_executing_the_request');
                                }
                                this._getBulkActionResult();
                            }
                        } else if (this.syncType === ExchangeBuklActionType.remove) {
                            if (res.failedNum === 0) {
                                this.bulkFinishedResult = StringLiteralsPipe.translate('crm.bulk_action_complete_succeed');
                            } else {
                                // this.bulkFinishedTip = StringLiteralsPipe.translate('crm.error_executing_the_request');
                                this.bulkFinishedResult = StringLiteralsPipe.translate('crm.bulk_action_complete_failed');
                            }

                            if (this.isShowBulkFailedResult) {
                                this._getBulkActionResult();
                            } else {
                                this._reload(this._getParams(), INIT);
                            }
                        }
                        this.progressColor = this._getProgressColor();
                        clearInterval(_this.interval);
                        this.page = 1;
                        if (this.isShowBulkFailedResult) {
                            this.loading = false;
                        }
                    }
                });
        }, 5 * 1000);
    }

    /**
     * getIndividualSubscriptionConfig for judge email is invalid
     *
     * @private
     * @memberof ContactListComponent
     */
    private _getIndividualSubscriptionConfig() {
        this._exchangeService.getIndividualSubscriptionConfig().pipe(
            take(1),
            catchError((error) => {
                this.isShowSynchLabel = true;
                const _failedToast: NotificationOptions = {
                    message: error.message,
                    style: NotificationStyles.Error

                };
                this._toast.notify(_failedToast);
                return observableOf(null);
            }),
        ).subscribe(res => {
            if (res) {
                this._slideSheetService.slideSheetActionSubject$.next({
                    type: SlideSheetActionTypes.EXCHANGE_SYNC_CONTACT,
                    payload: {
                        slideSheetAutoClose: false,
                        autoClose: false,
                        isFromAdminSetting: false
                    }
                });
            }
        });
    }

    /**
     * keyword search handler
     * @param feedback
     */
    private _keywordSearchFeedbackHandler(feedback) {
        if (feedback && feedback.type === 'CHANGE' && feedback.payload) {
            this.keyword = feedback.payload.state;
            this.page = 1;
            this._reload(this._getParams(), 'keyword');
        }
    }

    private _loadEmailWithSendTo() {
        let emailList = '';
        try {
            // get email list
            emailList = this.contactList.contacts.filter(contact => (contact['isChecked'] && contact.primaryEmail !== '')).map(item => item.primaryEmail).join(';');
            // open local client email and attch email list
            const mailObj = CommonUtilities.openLocalEmail(emailList);
            if (mailObj && mailObj.open && !mailObj.closed) {
                // local new email app is opened successfully.
            } else {
                // open office outlook in browser, the login page will open if no permission
                CommonUtilities.openOfficeOutlookWithBrowser(emailList);
            }
        } catch (e) {
            // open office outlook in browser, the login page will open if no permission
            CommonUtilities.openOfficeOutlookWithBrowser(emailList);
        }
    }

    /**
     * Recived server notification and get bulk contact list.
     * @param action
     */
    private _onMessageAction(action) {
        if (action.type === MessageType.BULK_OPERATOIN) {
            const _bulkToast: NotificationOptions = {
                message: 'Bulk edit successfully',
                style: NotificationStyles.Info
            };
            this.bulkProgress = '100%';
            this.page = 1;
            this._toast.notify(_bulkToast);
            if (!this.isShowBulkAction) {
                clearInterval(this.interval);
                this.isShowGrid = true;
                return;
            }
            this.splitButtonConfig.feedbackSubject$.next(false);
            if (action.payload && action.payload.isDone && action.payload.failedNum > 0) {
                this._getBulkActionResult();
            }
        }
    }

    private _onBulkButtonClick(syncType = 1) {
        this.syncType = syncType;
        let bulkTip = StringLiteralsPipe.translate('crm.one_way_bulk_tip', this.checkCount().toString());
        if (syncType === ExchangeBuklActionType.takeTwoWay) {
            bulkTip = StringLiteralsPipe.translate('crm.two_way_bulk_tip', this.checkCount().toString());
        }
        if (syncType === ExchangeBuklActionType.remove) {
            bulkTip = StringLiteralsPipe.translate('crm.three_way_bulk_tip', this.checkCount().toString());
        }
        this._alert.warn(StringLiteralsPipe.translate('crm.bulk_action_confirmation_required'), [bulkTip], 'Confirm', 'Discard', '', '', AlertBtnTypes.primary).pipe(
            take(1),
        ).subscribe(result => {
            if (result) {
                if (syncType === ExchangeBuklActionType.takeOneWay || syncType === ExchangeBuklActionType.takeTwoWay) {
                    this._resetProgressParams();
                    this.isProgressing = true;
                    this.bulkProgress = '0%';
                    this.isShowProgressBar = true;
                    this.splitButtonConfig.feedbackSubject$.next(true);
                    this.bulkProgressHeader = StringLiteralsPipe.translate('crm.progress_header', this.checkCount().toString());
                }
                // should get new filter data from useSetting store.
                this._userSetting = this._storeQuerier.queryBySelector(userSettingSelector);
                if (this._userSetting && this._userSetting.contactFilter) {
                    this.filterParams = this._userSetting.contactFilter.configuration.filterParams;
                }
                if (this.syncType === ExchangeBuklActionType.remove && this._oneBulkActionId) {
                    this._oneBulkActionFailId = _lodash.cloneDeep(this._oneBulkActionId);
                }
                if (this.syncType === ExchangeBuklActionType.remove) {
                    this.loading = true;
                }
                this._contactService.createContactBulkAction(this.keyword, this.filterParams, Array.from(this.uncheckList), syncType, this._oneBulkActionId, this.hasBulkOnce)
                    .pipe(take(1),
                        catchError((error) => {
                            const _failedToast: NotificationOptions = {
                                message: error.message,
                                style: NotificationStyles.Error
                            };
                            this._toast.notify(_failedToast);
                            this.isShowProgressBar = false;
                            this.splitButtonConfig.feedbackSubject$.next(true);
                            this._changeDetectorRef.detectChanges();
                            return observableOf(null);
                        }))
                    .subscribe(res => {
                        if (res) {
                            this._oneBulkActionId = res.id;
                            this._getBulkStatusByInterval();
                        }
                    });
            }
        });
    }

    private _onClicked(index) {
        this.selectedIndex = index;
        this.config.feedbackSubject.next(new ContactListFeedBack(ContactListFeedbackType.SELECTED, this.contactList[this.selectedIndex]));
    }

    /**
     * support to  export contact to excel
     * @param event
     */
    private _onOperationExportMenuSelect(event) {
        if (event.payload) {
            const id = event.payload.id;
            switch (id) {
                case '0':
                    this.page = 1;
                    this.isExportCurrentViewAll = true;
                    this._reload(this._getParams(), INIT);
                    break;
                case '1':
                    this.downloadAllContactListToExcel();
                    break;
            }
        }
    }

    private _onOperationMenuSelect(event) {
        if (event.payload) {
            const id = event.payload.id;
            switch (id) {
                case '0':
                    const exchangeDialogOptions = new ExchangeDialogOptions();
                    this._exchangeImportCheckDialogService.dialogOpen$.next(exchangeDialogOptions);
                    break;
                case '1':
                    this._getIndividualSubscriptionConfig();
                    break;
                case '2':
                    this.isShowBulkAction = true;
                    this.gridOptions.rowGroupPanelShow = NEVER;
                    this.isShowBulkFailedResult = false;
                    this._initSplitButton();
                    // Can't update columnDefs directly ,so reset columnDefs.
                    const data = _lodash.cloneDeep(this.columnDefs);
                    data.splice(0, 0, this._contactListService.checkColumnDef);
                    data.forEach(item => {
                        if (item.colId === 'owner' && item.hide) {
                            item.hide = false;
                        }
                    });
                    // add delete column to grid
                    if (this._isAdminUser && this._isComplianceUser) {
                        data.push(this._contactListService.deleteColumnDef);
                    }
                    this.columnDefs = [];
                    this._gridApi.setColumnDefs(this.columnDefs);
                    this.columnDefs = data;
                    this._gridApi.setColumnDefs(this.columnDefs);
                    this.contactList.contacts.forEach(item => item['isChecked'] = true);
                    this._gridApi.setRowData(this.contactList.contacts);
                    break;
                case '3':
                    this._synchTamaleContactFromExchagne(3);
                    break;
            }
        }
    }

    private _onSubscribeContactList(state) {
        this.noData = !(state && state.contactList && state.contactList.contacts && state.contactList.contacts.length > 0);
        this.contactList = state.contactList;
        if (this.contactList) {
            this.exportContextMenuConfig.items = [
                { id: '0', text: StringLiteralsPipe.translate('crm.export_current_contacts_to_excel', this.contactList.totalCount.toString()) },
                { id: '1', text: StringLiteralsPipe.translate('crm.export_all_contacts_to_excel', this.contactList.totalCount.toString()) }
            ];
        }

        this.contactList.contacts.forEach(item => {
            if (this.uncheckList.has(item.id)) {
                item['isChecked'] = false;
            }
        });
        this.loading = false;
        if (this.isRefresh) {
            const notification: NotificationOptions = {
                message: StringLiteralsPipe.translate('crm.contact_list_is_refreshed'),
                style: NotificationStyles.Info

            };
            this._toast.notify(notification);
        }
        this._postReload(state.params);

        // export all contacts to excel
        if (this.isExportCurrentViewAll) {
            this.isExportCurrentViewAll = false;
            this.downloadCurrentContactListToExcel();
        }
    }

    private _postReload(params: any) {
        // Assign the datasource for ag-grid
        if (this.contactList && this.contactList.contacts && this.contactList.contacts.length > 0) {
            if (!this.reloading && !this.loadingMore) {
                this._gridApi.setRowData(this.contactList.contacts);
            }
            if (this.reloading) {
                this._gridApi.setRowData(this.contactList.contacts);
                this.reloading = false;
                this._gridApi.sizeColumnsToFit();
                const scrollIndex = (this.page - 1) * DEFAULT_PAGE_SIZE + 1;
                this._gridApi.ensureIndexVisible(scrollIndex);
                if (params && params.workflow === 'external' && params.keyword !== this.keyword) {
                    this.keywordSearchConfig.actions$.next({ type: 'SET', payload: params.keyword, silentChange: true });
                }
            }

            if (this.loadingMore) {
                this.loadingMore = false;
                const startRowIndex = (this.page - 1) * DEFAULT_PAGE_SIZE;
                const endRowIndex = this.page * DEFAULT_PAGE_SIZE;
                this._gridApi.updateRowData({
                    add: this.contactList.contacts.slice(startRowIndex, endRowIndex)
                });
            }
        } else {
            this._gridApi.setRowData([]);
            this.contactId = null;
            this.reloading = false;
        }
        if (this._selectedId) {
            this._setSelectedRow(this._selectedId);
        }
        this.inited = true;
        this._selectedId = '';
    }

    private _prepareAction(action: any, prefix: string, instanceId: string) {
        if (action && prefix && instanceId) {
            action[prefix] = instanceId;
        }
        return action;
    }

    private _reload(conditions, workflow, isRefresh = false) {
        if (!this._userSetting) {
            this.isReload = true;
            this._store.dispatch({
                type: UsersActionTypes.LOAD_USER_SETTING
            });
            return;
        }
        if (workflow !== 'scroll') {
            this.reloading = true;
        }
        this.isRefresh = isRefresh;
        const action = this._prepareAction({
            type: RELOAD_CONTACTS,
            payload: Object.assign({ workflow: workflow }, conditions)
        }, this.config.keywordField, this.config.instanceId);
        this._store.dispatch(action);
    }

    private _resetProgressParams() {
        this.isShowBulkFailedResult = false;
        this.isProgressing = false;
        this.isShowProgressBar = false;
        this.isShowGrid = true;
        this.bulkProgress = '0%';
        this.bulkFinishedResult = `Bulk action is ${this.bulkProgress} complete`;
        this.bulkFinishedTip = '';
        this.keywordSearchConfig.keyword = this.keyword;
    }

    private _resetDataAfterClick() {
        this.isShowBulkAction = false;
        if (this._oneBulkActionId && !this.isProgressing) {
            this._contactService.deleteOneBulkOperation(this._oneBulkActionId).subscribe(res => { });
        }
        // set columnDefs = [] to refresh cloumndef cache.
        // Due to this._gridApi maybe null,add settimeout when reset columnDefs.
        setTimeout(() => {
            if (this._gridApi) {
                this.columnDefs = [];
                this._gridApi.setColumnDefs(this.columnDefs);
                this.columnDefs = _lodash.cloneDeep(this.columnDefsOrignal);
                this._gridApi.setColumnDefs(this.columnDefs);
            }
        }, 300);

        this._oneBulkActionId = '';
        this.uncheckList.clear();
        this._resetProgressParams();
        this.page = 1;
        this.gridOptions.rowGroupPanelShow = NEVER;
        this._reload(this._getParams(), INIT);
    }

    private _setSelectedRow(selectedId: string): void {
        this.gridOptions.api.forEachNode(node => {
            if (node.data.id === selectedId) {
                node.setSelected(true);
            }
        });
    }

    /**
     * save column setting by to server and store.
     * @param column
     */
    private _saveState(column?) {
        const gridColumns = column || this._gridColumnApi.getColumnState();
        const userSettingConfig = {
            contactListColumn: {
                'setting': gridColumns
            },
        };
        this._clearTimer();
        this._timer = setTimeout(() => {
            this._store.dispatch({
                type: UsersActionTypes.UPDATE_USER_SETTING,
                payload: userSettingConfig
            });
        }, AUTO_SAVE_INTERVAL_5);
    }

    /**
     * save sort change to server and store
     * @param sortInfo
     */
    private _triggerSortChanged(sortInfo: SortInfo) {
        const userSettingConfig = {
            contactListSort: {
                sortInfo
            },
        };
        this._store.dispatch({
            type: UsersActionTypes.UPDATE_USER_SETTING,
            payload: userSettingConfig
        });
    }

}
